import { ReactNode } from 'react'

import { ContextProvider } from './auth.context'

export function AuthProvider({ children }: { children: ReactNode }) {
  return <ContextProvider>{children}</ContextProvider>
}
